import { render, staticRenderFns } from "./BankSlipForm.vue?vue&type=template&id=de7ecfbe&scoped=true&"
import script from "./BankSlipForm.vue?vue&type=script&lang=ts&"
export * from "./BankSlipForm.vue?vue&type=script&lang=ts&"
import style0 from "./BankSlipForm.vue?vue&type=style&index=0&id=de7ecfbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7ecfbe",
  null
  
)

export default component.exports